<template>
  <admin-wrapper
    title-translation-path="admin.billing"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    @change="editSingleSettingHandler"
    :is-form-fetched="isFormFetched"
    @save="saveCard"
  >
    <template #waterMetersFeatureCard.input>
      <draggable-lists-manage-card
        left-title="admin.featureCardBilling"
        :layer-id="waterMetersLayerId"
        @update:hasAnyRequiredOnRightSide="hasAnyRequiredOnRightSide = $event"
        :has-edit-attributes="true"
      >
      </draggable-lists-manage-card>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';

export default {
  name: 'BillingsSettings',
  components: {
    AdminWrapper,
    DraggableListsManageCard,
  },
  data: () => ({
    isFormFetched: false,
  }),
  computed: {
    currentLayerSchema: get('layers/currentLayerSchema'),
    waterMetersDataSourceName: get('admin/modulesMapping@billing.watermeters_datasource_name'),
    waterMetersLayerId: get('admin/modulesMapping@billing.layer_id'),
    isModuleEnabled: get('admin/settingsValues@billings_module_enabled'),
    isSmsModuleEnabled: get('admin/additionalModules@SMS.enabled'),
    isSmsSettingsEnabled: get('admin/settingsValues@sms_module_enabled'),
    moduleEnabler() {
      return {
        name: 'billings_module_enabled',
        translationPath: 'admin.billing',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.billing') }),
      };
    },
    inputs() {
      const inputs = [
        {
          name: 'billings_module_legalization_soon_threshold',
          translationPath: 'admin.billingsModuleLegalizationSoonThreshold',
          align: 'start',
          dataType: {
            name: 'integer',
          },
          subtitle: 'admin.billingsModuleLegalizationSoonThresholdSubtitle',
        },
      ];
      if (this.isSmsModuleEnabled && this.isSmsSettingsEnabled) {
        inputs.push({
          name: 'billing_sms_sending_enabled',
          translationPath: 'admin.smsDispatch',
          dataType: {
            name: 'switch',
          },
          subtitle: 'admin.smsDispatchSubtitle',
        });
      }
      inputs.push({
        name: 'waterMetersFeatureCard',
        translationPath: 'admin.featureCardBilling',
        isCustom: true,
        subtitle: this.$i18n.t('admin.setFeatureCard', { type: this.$i18n.t('admin.billingType') }),
        align: 'start',
      });
      return inputs;
    },
  },
  methods: {
    editLayer: call('layers/editLayer'),
    editSingleSetting: call('admin/editSingleSetting'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    editSingleSettingHandler(value, name) {
      if (name === 'billings_module_legalization_soon_threshold' || name === 'billing_sms_sending_enabled') {
        this.editSingleSetting({
          key: name,
          body: {
            value,
          },
        });
      } else {
        return;
      }
    },
    async init() {
      await this.getModulesMapping();
      await Promise.all([
        this.getDataSourceForm(this.waterMetersDataSourceName),
        this.getFeaturesLayer(this.waterMetersLayerId),
        this.getLayerMetadata({ dataSource: this.waterMetersDataSourceName }),
      ]);
      this.isFormFetched = true;
    },
    async saveCard() {
      await this.editLayer({
        layer_type: 'features_layers',
        layer_id: this.waterMetersLayerId,
        body: {
          form_schema: {
            elements: this.currentLayerSchema,
          },
        },
      });
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
